import { Query } from '@/_core/cqrs/types/queries';

export interface ExampleStorymapCloneTargetProductModel {
    ProductId: string;
    ProductName: string;
}

export interface ExampleStorymapCloneTargetWorkspaceModel {
    WorkspaceId: number;
    WorkspaceName: string;
    WorkspaceSubdomain: string;
    Products: ExampleStorymapCloneTargetProductModel[];
}

export interface ExampleStorymapCloneTargetsResult {
    Workspaces: ExampleStorymapCloneTargetWorkspaceModel[];
}

export class ExampleStorymapCloneTargetsQuery extends Query<ExampleStorymapCloneTargetsResult> {
    constructor() {
        super('ExampleStorymapCloneTargetsQuery');
    }
}
